import React, { useState } from 'react';
import sharedStyles from './Modals.module.css';
import styles from './RateEpisodeVariationModal.module.css';

const DOT_OPTIONS = [
    { value: 1, label: 'Poor',  cls: styles.dp1 },
    { value: 2, label: 'Weak',  cls: styles.dp2 },
    { value: 3, label: 'OK',    cls: styles.dp3 },
    { value: 4, label: 'Good',  cls: styles.dp4 },
    { value: 5, label: 'Exc.', cls: styles.dp5 },
];

const RateEpisodeVariationModal = ({ episodeCount, onConfirm, onClose }) => {
    const [selected, setSelected] = useState(null);

    const handleConfirm = () => {
        if (selected === null) return;
        onConfirm(selected);
    };

    return (
        <div className={sharedStyles.overlay} onClick={(e) => { if (e.target === e.currentTarget) onClose(); }}>
            <div className={styles.shell}>

                <div className={styles.head}>
                    <div className={styles.headLeft}>
                        <span className={styles.eyebrow}>Before you submit</span>
                        <span className={styles.title}>Rate episode variation</span>
                    </div>
                    <button type="button" className={sharedStyles.closeBtn} onClick={onClose}>&#215;</button>
                </div>

                <div className={styles.body}>
                    <div className={styles.diversityBox}>
                        <div className={styles.diversityBoxTitle}>Variation across all episodes</div>
                        <div className={styles.ratingArea}>
                            <div className={styles.ratingRow}>
                                {DOT_OPTIONS.map((opt) => {
                                    const isSelected = selected === opt.value;
                                    return (
                                        <div
                                            key={opt.value}
                                            className={`${styles.dotWrap}${isSelected ? ` ${styles.selected}` : ''}`}
                                            onClick={() => setSelected(opt.value)}
                                        >
                                            <div className={`${styles.dot}${isSelected ? ` ${opt.cls}` : ''}`} />
                                            <span className={styles.dotLabel}>{opt.label}</span>
                                        </div>
                                    );
                                })}
                            </div>
                        </div>
                        <div className={styles.diversityDesc}>
                            Having reviewed {episodeCount === 1 ? `${episodeCount} episode` : ` all ${episodeCount} episodes`}, how varied {episodeCount === 1 ? 'was it' : 'were they'} overall? Consider differences in environment, scene setup, objects, and actions.
                        </div>
                    </div>
                </div>

                <div className={styles.footer}>
                    <button
                        type="button"
                        className={styles.btnPrimary}
                        onClick={handleConfirm}
                        disabled={selected === null}
                    >
                        <svg width="12" height="12" viewBox="0 0 13 13" fill="none">
                            <path d="M2 6.5l3.5 3.5 5.5-6" stroke="#111" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                        Confirm submission
                    </button>
                    <button type="button" className={styles.btnSecondary} onClick={onClose}>
                        Go back
                    </button>
                </div>

            </div>
        </div>
    );
};

export default RateEpisodeVariationModal;
